import { AppState } from '../../types';
import { StateListCredits } from './types';

export const selectCreditList = (state: AppState) :StateListCredits => state.credits.list;

export const selectAdjustCredits = (state: AppState) => state.credits.adjustCredit;

export const selectTransferCredits = (state: AppState) => state.credits.transferCredit;
